import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import('./polyfills');

Promise.all([
  import('./App'),
  import('./store'),
])
  .then(imports => imports.map(i => i.default))
  .then(([
    App,
    store,
  ]) => {
    ReactDOM.render(
      <Provider store={store}>
        <App />
      </Provider>,
      document.getElementById('root'),
    );
  });




// WEBPACK FOOTER //
// ./src/index.js